// Company: Ajinsoft
// Author: Uilan Coqueiro
// Date: 2023-03-30

import { Subject } from "rxjs";

export class MediaScreen {

    public change: Subject<void> = new Subject<void>();

    xs: boolean = false;
    sm: boolean = false;
    md: boolean = false;
    lg: boolean = false;
    xl: boolean = false;


    // sm: '(min-width: 600px)',
    // md: '(min-width: 960px)',
    // lg: '(min-width: 1280px)',
    // xl: '(min-width: 1440px)'
}
